import { Platform } from "react-native";
import { BuildBootstrapFunctionReturn } from "@lookiero/messaging-react";
import { fetchHttpPost } from "@lookiero/sty-psp-http";
import { VERSION } from "../../version";
import { httpCategoriesOfferingEnabledView } from "../projection/offering/httpCategoriesOfferingEnabledView";
import { httpCompleteYourLookOfferingEnabledView } from "../projection/offering/httpCompleteYourLookOfferingEnabledView";
import { httpSalesOfferingEnabledView } from "../projection/offering/httpSalesOfferingEnabledView";
import { httpTrendingForYouOfferingEnabledView } from "../projection/offering/httpTrendingForYouOfferingEnabledView";
import { baseBootstrap } from "./baseBootstrap";

type OS = typeof Platform.OS;
type Device = Exclude<OS, "macos" | "windows">;
const device = Platform.OS as Device;

interface BootstrapFunctionArgs {
  readonly getAuthToken: () => Promise<string>;
  readonly apiUrl: () => string;
}

interface BootstrapFunction {
  (args: BootstrapFunctionArgs): BuildBootstrapFunctionReturn;
}

const bootstrap: BootstrapFunction = ({ apiUrl, getAuthToken }) => {
  const httpPost = fetchHttpPost({ apiUrl, getAuthToken, device, version: VERSION });

  return baseBootstrap({
    isCompleteYourLookOfferingEnabledView: httpCompleteYourLookOfferingEnabledView({ httpPost }),
    isCategoriesOfferingEnabledView: httpCategoriesOfferingEnabledView({ httpPost }),
    isSalesOfferingEnabledView: httpSalesOfferingEnabledView({ httpPost }),
    isTrendingForYouOfferingEnabledView: httpTrendingForYouOfferingEnabledView({ httpPost }),
  });
};

export { bootstrap };
